import { IAnexo } from "../../../utility/IAnexo";

export interface ArquivoUploadInfo {
    arquivo: File;
    progresso: number;
    status: "enviando" | "sucesso" | "erro";
    erro?: string;
}

export const extrairNomeArquivo = (anexo: IAnexo) => {
    if (anexo.caminho) {
        return anexo.caminho.split("/").pop() || anexo.caminho;
                    }
    return anexo.arquivo_final || "arquivo";
};

export const extrairExtensao = (nome: string) => {
    return nome.split(".").pop()?.toUpperCase() || "";
};

export const obterInformacoesResponsavel = (anexo: IAnexo) => {
    return {
        responsavel: anexo.nome_responsavel || "—",
        tipo: anexo.tipo_responsavel || ""
    };
};
